var a = /* @__PURE__ */ ((r) => (r["1.0.0"] = "1.0.0", r))(a || {});
export {
  a as ProfileEventsVersionsEnum,
  a as default
};
//# sourceMappingURL=profileEventsVersionsEnum.js.map
